export default {
  CITY: `Ville`,
  COUNTRY: `Pays`,
  FLOOR: `Étage`,
  ROOM: `Salle/Appartement`,
  STREET_ADDRESS: `Rue`,
  STATE: `État`,
  ZIP_CODE: `Code postal`,
  SEARCH_FOR_AN_ADDRESS: `Chercher une adresse`,
  ADD_AN_ADDRESS: `Ajouter une adresse`,
  START_TAPPING_TO_SEARCH: `Commencez à écrire pour débuter la recherche`,
  ADDRESS: `Adresse :`,
  ADD: `Ajouter`,
  NO_ADDRESS_ENTERED: `Aucune addresse entrée`,
  EDIT_ADDRESS: `Modifier l'adresse`,
  CANCEL: `Annuler`,
  UPDATE: `Mise à jour `,
  GEOFENCE_RADIUS: `Rayon de géorepérage`
}
